<template>
  <CHeader
    fixed
    with-subheader
    light
    class="d-flex justify-content-between align-items-center"
  >
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />

    <CHeaderNav class="ml-4">
      <TheHeaderDropdownAccnt />
    </CHeaderNav>
    <CSubheader class="px-3">
      <CBreadcrumbRouter class="border-0 mb-0">
        <template v-if="lastRouteName !== null">
          <div class="added-item">
            &nbsp;<span class="primary">/</span> &nbsp;{{ lastRouteName }}
          </div>
        </template>
      </CBreadcrumbRouter>
    </CSubheader>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";

export default {
  name: "TheHeader",
  components: {
    TheHeaderDropdownAccnt,
  },
  props: {
    lastRouteName: {
      type: String,
      default: null,
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .breadcrumb-item + .breadcrumb-item::before {
    color: #fbad18;
  }
}
.added-item {
  color: #768192;
}
</style>
